import { addNotification } from '@onhandtech/onhand-fe-shared/lib/notifications'
import type { ReduxModuleResultPayloadAction } from '@onhandtech/onhand-fe-shared/lib/redux'
import { put } from 'redux-saga/effects'

import slice from '../../../../create-organisation'
import type { CreateOrganisationResponse } from '../organisations.module.types'

export function* createOrganisationSuccessSaga({
  payload,
  formatMessage,
}: ReduxModuleResultPayloadAction<CreateOrganisationResponse>) {
  yield put(slice.actions.resetForm())

  if (formatMessage) {
    yield put(
      addNotification({
        id: 'create-organisation-success',
        variant: 'success',
        title: formatMessage({
          id: 'notifications.organisation.create.success.title',
        }),
        description: formatMessage(
          {
            id: 'notifications.organisation.create.success.description',
          },
          { organisation: payload.name },
        ),
      }),
    )
  }
}
